import {
  Component,
  OnInit,
  Renderer2,
  OnDestroy,
  Input,
  ViewChild,
  Inject,
  ElementRef,
  HostListener,
  LOCALE_ID,
} from "@angular/core";
import { Subscription } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { OfferService } from "../services/offer/offer.service";
import { ToastrService } from "ngx-toastr";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { LoginComponent } from "src/app/shared/components/login/login.component";
import { AuthService } from "src/app/shared/services/auth/auth.service";
import { TncComponent } from "../tnc/tnc.component";
import { Meta, Title } from "@angular/platform-browser";
import { CommonService } from "src/app/shared/services/common/common.service";
import { appConstants } from "src/app/shared/constants/app.constants";
import { CouponModalComponent } from "src/app/shared/components/coupon-modal/coupon-modal.component";
import { DataTransferService } from "src/app/shared/services/common/datatransfer.service";
import { Location } from "@angular/common";

import { Store } from "@ngrx/store";
import { select } from "@ngrx/store";
import * as redemptionActions from "src/app/store/actions/redemptions.action";
import { ILanguage } from "src/app/shared/components/header/header.component";
import { AdobeAnalyticsService } from "src/app/shared/services/common/adobeAnalytics.service";

@Component({
  selector: "app-detail",
  templateUrl: "./detail.component.html",
  styleUrls: ["./detail.component.scss"],
})
export class DetailComponent implements OnInit, OnDestroy {
  @ViewChild("merchantDescription") merchantDescription: ElementRef<any>;

  progress: boolean = true;
  offersList = [];
  selectedOffer;
  modalRef: BsModalRef | null;
  activeOffer = 0;
  showMobTnc: boolean = false;
  inputToShow;
  merchant;
  category;
  voucherData;
  merchant_id;
  merchant_name;
  initialClaimData;
  showReadMoreButton: boolean = false;
  readMore: boolean = false;
  loadingRedemptions = false;
  refreshSubscription: Subscription;
  offerDetails: any;
  public isAuthenticated: boolean = this._authService.isAuthenticated();
  @HostListener("unloaded")
  ngOnDestroy() {
    // this.dataTransferService.nextMessage(null)
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
    this.elementRef.nativeElement.remove();
    if (this.modalRef) {
      this.modalRef.hide();
    }
    this.dataTransferService.nextMerchantOfferData(null);
  }
  constructor(
    private activatedRoute: ActivatedRoute,
    private offerService: OfferService,
    private renderer: Renderer2,
    private toastr: ToastrService,
    private title: Title,
    public _authService: AuthService,
    private commonService: CommonService,
    private router: Router,
    private modalService: BsModalService,
    private dataTransferService: DataTransferService,
    private elementRef: ElementRef,
    private location: Location,
    private readonly store: Store,
    private meta: Meta,
    @Inject(LOCALE_ID) public locale: string,
    public adobeAnalyticsService: AdobeAnalyticsService
  ) {
    this.activatedRoute.params.subscribe((params) => {
      this.merchant_id = params.id;
      if (this.merchant_id) {
        this.getOffers(this.merchant_id);
      }
    });
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      if (!queryParams.terms && this.modalRef) {
        this.modalRef.hide();
      } else if (queryParams.terms && !this.modalRef && this.offersList) {
        let selectedOffer = this.offersList.find((merc) => {
          return (
            merc.attributes?.id ===
            this.activatedRoute.snapshot.queryParamMap.get("offer_id")
          );
        });
        if (selectedOffer) {
          this.openTncModal(selectedOffer);
        }
      }
    });
  }

  ngOnInit() {
    this.title.setTitle("Offers & Privileges - " + appConstants.baseTitle);
    this.meta.addTag({
      rel: "canonical",
      href: appConstants.canonicalUrl + this.router.url,
    });
    window.scrollTo(0, 0);
    this.checkRefresh();
  }
  redemptions;
  getRedemptions(refreshRedemptions = false, refreshVoucher = false) {
    this.store
      .pipe(select((state: any) => state.redemptions))
      .subscribe((res) => {
        if (!refreshRedemptions && res && res.redemptions) {
          if (res.redemptions?.total_count > 0) {
            this.redemptions = res.redemptions;
            this.checkRedemptions(refreshVoucher);
          } else {
            this.loadingRedemptions = false;
          }
          refreshVoucher = false;
        } else {
          this.store.dispatch(redemptionActions.getRedemptions({}));
        }
        refreshRedemptions = false;
      });
  }
  checkRedemptions(refreshVoucher = false) {
    this.offersList.forEach((offer) => {
      if (
        refreshVoucher ||
        (offer.attributes.redemption_type &&
          offer.attributes.redemption_type !== "multiple_redemption_allowed")
      ) {
        let couponObj = this.redemptions.data.find((obj) => {
          return obj.attributes?.offer?.id === offer.id;
        });
        if (couponObj) {
          offer["voucherData"] = couponObj;
        }
      }
    });
    this.loadingRedemptions = false;
  }

  getOffers(id, reloadRedemptions = true) {
    if (sessionStorage.getItem("userLanguage")) {
      this.getOffersApi(id, reloadRedemptions);
    } else {
      this.commonService
        .getLanguages()
        .toPromise()
        .then((res: { data: ILanguage[] }) => {
          const selectedLanguage = res?.data.find(
            (language: ILanguage) =>
              language?.attributes?.iso639_1 === this.locale
          );
          if (selectedLanguage) {
            this.commonService.changeLanguageEmit(selectedLanguage);
          }
          this.getOffersApi(id, reloadRedemptions);
        })
        .catch((err) => {
          console.log("error while fetching languages", err);
          this.getOffersApi(id, reloadRedemptions);
        });
    }
  }

  private getOffersApi(id, reloadRedemptions = true) {
    this.offerService.getOffersByMerchant(id).then((res: any) => {
      if (res.data.length < 1) {
        this.toastr.show(
          $localize`Sorry! offer not applicable. Redirecting to home page.`,
          $localize`Offer not applicable`,
          {
            timeOut: 5000,
            disableTimeOut: "extendedTimeOut",
            tapToDismiss: false,
            progressBar: true,
          }
        );
        setTimeout(() => {
          this.router.navigate(["/"]);
        }, 3000);
      }

      if (res.data) {
        this.offerDetails = res.data[0];        
        this.offersList = res.data;
        if (this._authService.isAuthenticated()) {
          if (reloadRedemptions) {
            // this.loadingRedemptions = true;
            // this.getRedemptions();
          }
        } else {
          this.loadingRedemptions = false;
        }

        res?.included?.forEach((obj) => {
          if (obj.type == "merchant") {
            this.merchant = obj;
            setTimeout(() => {
              if (
                this.merchantDescription.nativeElement.offsetHeight <
                  this.merchantDescription.nativeElement.scrollHeight ||
                this.merchantDescription.nativeElement.offsetWidth <
                  this.merchantDescription.nativeElement.scrollWidth
              ) {
                this.showReadMoreButton = true;
              }
            }, 100);
            this.merchant_name = this.merchant.attributes.name;
            this.title.setTitle(
              this.merchant.attributes.name +
                " - Offers & Privileges - " +
                appConstants.baseTitle
            );
          }
          if (obj.type === "category" && obj?.attributes?.parent_id) {
            this.category = obj?.attributes;
          }
        });

        if (this.initialClaimData && this.initialClaimData.offer_id) {
          for (const each of this.offersList) {
            if (each.id === this.initialClaimData.offer_id) {
              this.initialClaimData = undefined;
              this.router.navigate(["."], { relativeTo: this.activatedRoute });
              setTimeout(() => {
                this.openTncModal(each);
              }, 100);
              break;
            }
          }
        } else if (this.activatedRoute.snapshot.queryParamMap.get("offer_id")) {
          if (this.activatedRoute.snapshot.queryParamMap.get("terms")) {
            let selectedOffer = this.offersList.find((merc) => {
              return (
                merc.attributes?.id ===
                this.activatedRoute.snapshot.queryParamMap.get("offer_id")
              );
            });
            if (selectedOffer) {
              this.openTncModal(selectedOffer);
            }
          } else {
            this.modalRef.hide();
          }
        }
        this.sendMerchantAndOfferData();
        this.sendAnalyticsDataOnload();
      }

      this.progress = false;
    });
  }

  openTncModal(offer, updateRoute = false, linkTrace = false) {
    if (linkTrace) {
      this.sendMerchantAnalyticsData("terms & conditions");
    } else {
      this.sendOfferAnalyticsData("terms & conditions", offer);
    }
    if (updateRoute) {
      this.router.navigate(["."], {
        relativeTo: this.activatedRoute,
        queryParams: {
          offer_id: offer.id,
          terms: "true",
        },
        queryParamsHandling: "merge",
        // skipLocationChange: true
      });
    }
    if (offer) {
      this.selectedOffer = offer;
      const initialState = {
        offer: this.selectedOffer,
        merchant: this.merchant,
      };
      var config = {
        backdrop: true,
        ignoreBackdropClick: false,
        class: "terms-modal",
        animated: false,
      };
      this.modalRef = this.modalService.show(
        TncComponent,
        Object.assign({}, config, { initialState })
      );

      this.modalRef.content.hideEvent.subscribe((res) => {
        if (res) {
          this.router.navigate(["."], {
            relativeTo: this.activatedRoute,
            queryParams: {
              offer_id: null,
              terms: null,
            },
            queryParamsHandling: "merge",
            // skipLocationChange: true
          });
          this.modalRef.hide();
        }
      });
    }
  }

  closeModal() {
    if (!this.modalRef) {
      return;
    }
    this.modalRef.hide();
    this.modalRef = null;
  }

  removeModalOpen() {
    this.renderer.removeClass(document.body, "modal-open");
  }
  addModalOpen() {
    this.renderer.addClass(document.body, "modal-open");
  }

  public toggleAccordion(inputToShow: string): void {
    this.addModalOpen();
    this.inputToShow = inputToShow;
    this.showMobTnc = true;
  }

  copy(couponCode) {
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = couponCode;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
    this.toastr.success("Coupon Copied!");
  }

  redeem(offer) {
    if (this._authService.isAuthenticated()) {
      this.sendOfferAnalyticsData("claim offer", offer);
      offer.showLoader = true;

      let selectedOffer = {
        merchantId: this.merchant_id,
        merchant_name: this.merchant?.attributes?.name,
        merchant_logo: this.merchant?.attributes?.logo_url,
        merchant_website: this.merchant?.attributes?.website,
        offer_title: offer.attributes.title,
        offer_type: offer.attributes?.offer_type,
        end_date: offer.attributes?.end_date,
        id: offer.attributes?.id,
        redemption_url: offer.attributes?.redemption_url,
      };
      this.openCoupon(selectedOffer, offer);
    } else {
      this.openLoginModal(offer);
    }
  }
  openLoginModal(offer) {
    var config = {
      backdrop: true,
      ignoreBackdropClick: false,
      class: "login-modal",
    };
    this.modalRef = this.modalService.show(
      LoginComponent,
      Object.assign({}, config, {})
    );
    this.modalRef.content.loginStatus.subscribe((res) => {
      if (res) {
        this.redeem(offer);
        // this.loadingRedemptions = true;
        this.getOffers(this.merchant_id, false);
      }
    });
    this.modalRef.content.closeModal.subscribe((res) => {
      this.modalRef.hide();
    });
  }
  openCoupon(selectedOffer, offer) {
    const initialState = {
      selectedOffer: selectedOffer,
      isDetailPage: true,
      category: this.category.code,
      clickPosition: this.merchant.attributes.name,
    };
    var config = {
      backdrop: true,
      ignoreBackdropClick: false,
      class: "coupon-modal",
    };
    this.modalRef = this.modalService.show(
      CouponModalComponent,
      Object.assign({}, config, { initialState })
    );
    this.modalRef.content.redeemStatus.subscribe((res) => {
      offer.attributes.claimable = false;
      offer.showLoader = false;
      // this.getRedemptions(true,true);
    });
    this.modalRef.content.hideEvent.subscribe((res) => {
      this.modalRef.hide();
      offer.showLoader = false;
    });
  }
  backClicked() {
    if (this.activatedRoute.snapshot.queryParamMap.get("terms")) {
      this.modalRef.hide();
    }
    this.router.navigate(["/"]);
  }
  checkLength(content) {
    return content.replace(/<[^>]*>/g, "").length;
  }
  checkRefresh() {
    if (!this.refreshSubscription) {
      this.refreshSubscription =
        this.dataTransferService.sharedRefreshEvent.subscribe((res) => {
          if (res && res.refresh) {
            // this.loadingRedemptions = true;
            this.getOffers(this.merchant_id);
          }
        });
    }
  }

  getRedirectionLink(linkType: string) {
    switch (linkType) {
      case "go_to_website":
        return this.merchant?.attributes?.website;

      case "terms & conditions":
        return window.location.href;
      default:
        return window.location.href;
    }
  }

  sendMerchantAnalyticsData(link_name: string) {
    const pageRedirectionLink = this.getRedirectionLink(link_name);
    const payload = {
      siteSection: "merchant_page",
      category: this.category.code,
      clickPosition: link_name.includes("terms")
        ? `offer_details|${this.merchant?.attributes?.name}`
        : `about_${this.merchant?.attributes?.name}`,
      pageURL: pageRedirectionLink,
      button_name: `${this.merchant.attributes.name}|${link_name}`,
      linkType: link_name.includes("read") ? "interaction" : "navigation",
    };
    this.commonService.sendAnalyticsData("link_click", "link", payload);
  }

  sendOfferAnalyticsData(link_name: string, offer: any) {   
    const payload = {
      siteSection: "merchant_page",
      category: this.category.code,
      clickPosition: this.merchant.attributes.name,
      offerName: offer.attributes.title,
      offerId: offer.id,
      merchantName: this.merchant?.attributes?.name,
      merchantID: this.merchant?.id,
      pageURL: window.location.href,
      button_name: `${this.merchant.attributes.name}|${link_name}`,
      linkType: "interaction",
    };
    this.commonService.sendAnalyticsData("offer_click", "offer", payload);
  }

  private sendMerchantAndOfferData() {
    const data = {
      offerName: this.offersList[this.activeOffer]?.attributes?.title,
      offerID: this.offersList[this.activeOffer]?.attributes?.id,
      merchantName: this.merchant?.attributes?.name,
      merchantID: this.merchant?.id,
      pageName: `Offer Page - ${this.merchant?.attributes?.name} - ${
        this.offersList[this.activeOffer]?.attributes?.title
      }`,
      contentType: "Offer Details",
    };
    this.dataTransferService.nextMerchantOfferData(data);
  }

  public sendAnalyticsDataOnload() {    
    this.adobeAnalyticsService.loadDataLayerScript({
      siteSection1: "Offer Page",
      siteSection2: "Detail Page",
      pageName: "Offer Detail Page",
      contentType: "Offer Page - " + appConstants.baseTitle,
      merchantName: this.merchant?.attributes?.name,
      merchantId: this.merchant_id,
      offerName: this.offerDetails?.attributes?.title,
      offerId: this.offerDetails?.attributes?.id,
    });
    this.commonService.sendAnalyticsData("pageLoad", "pageInfo", window["di"]);
  }
}
